// removed by extract-text-webpack-plugin
module.exports = {"readOnly":"c-DeliveryOptions__readOnly","shippingName":"c-DeliveryOptions__shippingName","shippingPrice":"c-DeliveryOptions__shippingPrice","button":"c-DeliveryOptions__button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/DeliveryOptions/DeliveryOptions.scss
// module id = 546
// module chunks = 0